var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.l_visible
    ? _c(
        "div",
        {
          directives: [
            {
              name: "click-outside",
              rawName: "v-click-outside",
              value: _vm.clickOutside,
              expression: "clickOutside"
            }
          ]
        },
        [
          _c(
            "div",
            { ref: "dtpTxt" },
            [
              _c(
                "v-text-field",
                {
                  ref: "control",
                  staticClass: "calendar-input dynamic-input-control",
                  class: {
                    validated:
                      _vm.displayValidated &&
                      !_vm.hasError &&
                      !_vm.errorMessages,
                    required: _vm.l_required,
                    naked: _vm.naked,
                    readonly: _vm.readonly || _vm.isDisabled || _vm.isLoading,
                    "hide-error-icon": _vm.hideErrorIcon
                  },
                  attrs: {
                    rules: _vm.getRules,
                    outlined: "",
                    label: _vm.getLabel,
                    "append-icon": _vm.getDisabled
                      ? ""
                      : _vm.tooltipAppendIcon.length == 0
                      ? _vm.icon
                      : "",
                    loading: _vm.isLoading,
                    value: _vm.strVal,
                    dense: _vm.dense,
                    placeholder: _vm.placeholder,
                    disabled: _vm.getDisabled,
                    "error-messages": _vm.errorMessages
                  },
                  on: {
                    focus: _vm.onFocus,
                    click: _vm.onFocus,
                    change: _vm.onTextChange,
                    keydown: _vm.keydown,
                    mousedown: _vm.handleMouseDown,
                    input: function(v) {
                      return (_vm.dirtyText = v)
                    }
                  }
                },
                [
                  !_vm.getDisabled && _vm.tooltipAppendIcon.length > 0
                    ? _c(
                        "template",
                        { slot: "append" },
                        [
                          _c(
                            "v-tooltip",
                            {
                              attrs: { top: "", "max-width": "350" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-icon",
                                          _vm._g(
                                            {
                                              staticClass:
                                                "btn-help ml-2 mt-1 text-body-2",
                                              staticStyle: { cursor: "pointer" }
                                            },
                                            on
                                          ),
                                          [_vm._v(" " + _vm._s(_vm.icon) + " ")]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3475077936
                              )
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.tooltipAppendIcon))
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  !!_vm.getTooltip
                    ? _c(
                        "template",
                        { slot: "append" },
                        [
                          !_vm.getDisabled && _vm.tooltipAppendIcon.length == 0
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "v-input__icon v-input__icon--append"
                                },
                                [_c("v-icon", [_vm._v(_vm._s(_vm.icon))])],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "", "max-width": "350" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-icon",
                                          _vm._g(
                                            {
                                              staticClass:
                                                "btn-help text-body-2 ml-2",
                                              attrs: { slot: "activator" },
                                              slot: "activator"
                                            },
                                            on
                                          ),
                                          [_vm._v("mdi-help-circle")]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1426974712
                              )
                            },
                            [
                              _c("span", [
                                _vm._v(" " + _vm._s(_vm.getTooltip) + " ")
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                2
              )
            ],
            1
          ),
          _c("v-slide-x-transition", [
            _c(
              "div",
              {
                ref: "dtp",
                staticClass: "date-picker-box-wrapper",
                style: { top: _vm.overflow + "px" }
              },
              [
                _c(
                  "v-date-picker",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showMenu,
                        expression: "showMenu"
                      }
                    ],
                    staticClass: "pa-0 date-picker-box",
                    attrs: {
                      "data-id": _vm.dataId,
                      type: _vm.type,
                      "no-title": "",
                      "first-day-of-week": "1",
                      locale: "sk-sk",
                      value: _vm.datePickerValue,
                      min: _vm.getMin,
                      max: _vm.getMax,
                      range: _vm.range,
                      readonly:
                        _vm.disabled ||
                        _vm.isDisabled ||
                        _vm.readonly ||
                        _vm.isLoading
                    },
                    on: { input: _vm.onInput, change: _vm.emitChange }
                  },
                  [
                    _c("v-spacer"),
                    _c(
                      "div",
                      { staticClass: "datepicker-buttons" },
                      [
                        !this.range
                          ? _c(
                              "v-btn",
                              {
                                staticClass: "left",
                                attrs: { text: "" },
                                on: { click: _vm.setToday }
                              },
                              [_vm._v(" Dnes ")]
                            )
                          : _vm._e(),
                        _c(
                          "v-btn",
                          {
                            staticClass: "right btn-clear-date",
                            attrs: { text: "" },
                            on: {
                              click: function($event) {
                                return _vm.deleteDate(true)
                              }
                            }
                          },
                          [_vm._v(" Vymazať ")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }